import React, { useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { MdPlaylistAdd } from 'react-icons/md';
import { FaTimes } from 'react-icons/fa';

import './AdditionalForm.css';

export default function AdditionalForm(props) {


  const additional = props.data


  useEffect(() => {
    //Component mounted
     addRow([])


    return () => {
      //Component unmounted
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Empty dependency array to run the effect


  const addRow = (arr, names = undefined) => {
    let ans = [...arr]
    if (names) {
      names.forEach((i) => ans.push({ name: i[0], amount: i[1], semester: i[2] },))
    }
    else {
      ans.push({ name: "", amount: 0, semester: "Both" },)
    }
    props.changeState(ans)
  }
  const delRow = (i) => {
    let ans = [...additional]
    ans.splice(i, 1)
    props.changeState(ans)
  }
  const changeRow = (i, attr, attr_type, value) => {
    if (attr_type(value)) {
      let ans = [...additional]
      ans[i][attr] = value
      props.changeState(ans)
    }
  }
  const additionalExpensesTable = () => {
    return (
      additional.map((field, i) => (
        <div key={i} className="field">
          <input className="name" value={field.name} onChange={(e) => changeRow(i, "name", (val) => (typeof val === 'string'),  e.target.value)}/>
          <select className="semester" onChange={(e) => changeRow(i, "semester", (val) => (typeof val === 'string'),  e.target.value)} value={field.semester} >
            <option value="Both">Both</option>
            <option value="Fall">Fall</option>
            <option value="Spring">Spring</option>
          </select>
          <input className="amount" value={field.amount} onChange={(e) => changeRow(i, "amount", (val) => /^(\d+)?(\.)?(\d+)?$/.test(val), e.target.value)} onBlur={(e) => e.target.value = parseFloat((e.target.value==="") ? 0 : e.target.value).toFixed(2)}/>
          { (i!==0) ? <FaTimes style={{float: "right", marginTop: "5px"}} size={20} onClick={() => delRow(i)}/> : null}
        </div>
      ))
    )
  }

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Additional Expenses Information  {(props.invalid) ? <FaTimes style={{ marginLeft: 'auto', marginTop: "5px", color: "red" }} size={30} /> : null}</Accordion.Header>
        <Accordion.Body>
          <div className="table">
            <h5>
              Additional Expenses
              <MdPlaylistAdd style={{ float: "right" }} size={30} onClick={() => addRow(additional)} />
            </h5>
            <div className="field">
              <h5 className="name">Name</h5>
              <h5 className="amount">Amount</h5>
            </div>
            {additionalExpensesTable()}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}